import { Injectable } from '@angular/core';
import { AppSettings, AsamcoAuthService } from '@asamco/base';
import { bind } from '@asamco/utils';
import { Observable, Subject } from 'rxjs';
import { AsamcoSignalrBase } from '@asamco/signal-r';
import { JobLogType } from '@asamco/application-link/shared';

@Injectable({
	providedIn: 'root',
	deps: [AsamcoAuthService, AppSettings],
})
export class LoggingUpdateSignalrService extends AsamcoSignalrBase {
	/**
	 * Our hubname to connect to
	 */
	protected hubName = 'Logging';

	/**
	 * The event name
	 */
	protected events = [{ methodName: 'loggingEntryAdded', newMethod: this.LoggingAddedUpdate }];

	private loggingSubject: Subject<any> = new Subject<any>();

	/**
	 *Creates an instance of NotificationSignalrService.
	 * @param signalr
	 * @param auth
	 * @param app
	 */
	constructor(auth: AsamcoAuthService, app: AppSettings) {
		super(auth, app);
	}

	@bind
	LoggingAddedUpdate(linkId: number, jobInstanceId: string, jobLogId: number, jobLogType: JobLogType) {
		this.loggingSubject.next({ linkId, jobInstanceId, jobLogId, jobLogType });
	}

	public getLoggerObservable(): Observable<any> {
		return this.loggingSubject.asObservable();
	}
}
